// Programme page "latest chapters" list. The server renders page 0 inside the mCustomScrollbar
// container (scripts.js initialises every .scrollbarContainer); we initialise this one ourselves
// so the plugin's onTotalScroll callback can fetch the next page from ProgrammeSurface/Latest
// and append its <li> tiles — mirrors the Angular scrollbar (reached) + postLatest pair.

const ENDPOINT = '/umbraco/surface/ProgrammeSurface/Latest';
const REACHED_BOTTOM_OFFSET = 80;

export function initProgrammeLatest() {
  document.querySelectorAll('[data-load-more="latest"]').forEach(initList);
}

function initList(el) {
  const $ = window.jQuery;
  const list = el.querySelector('.content');
  const programmeId = parseInt(el.dataset.programmeId, 10) || 0;
  const totalPages = parseInt(el.dataset.totalPages, 10) || 0;
  if (!$ || !$.fn.mCustomScrollbar || !list || !programmeId) return;

  let page = 0;
  let loading = false;

  async function loadMore() {
    if (loading || page + 1 >= totalPages) return;
    loading = true;
    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ programmeId, page: page + 1 })
      });
      if (!res.ok) throw new Error('programme latest failed: ' + res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      doc.body.querySelectorAll(':scope > li').forEach(li => list.appendChild(li));
      page++;
      $(el).mCustomScrollbar('update');
    } catch (e) { console.error(e); }
    loading = false;
  }

  const $el = $(el);
  if ($el.data('mCS')) $el.mCustomScrollbar('destroy');
  $el.mCustomScrollbar({
    autoHideScrollbar: true,
    callbacks: { onTotalScroll: loadMore, onTotalScrollOffset: REACHED_BOTTOM_OFFSET }
  });
}
